<template>
<vinput
  ref='vinput'
  :value="value"
  @input="set_phone"
  @keydown="keydown"
  @keyup="keyup"
  @focus="$emit('focus')"
  :valuetype="'phone'"
  :border="border"
  :error="error"
  :label="label"
  :input_event="true"
  :focus_area="focus_area"
  :placeholder="placeholder"
/>
</template>

<script>
import { formatIncompletePhoneNumber, parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js'
export default {
  name: 'vphone',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    error: {
      type: [String],
      default: ''
    },
    border: {
      type: [Boolean]
    },
    label: {
      type: [String]
    },
    placeholder: {
      type: [String]
    },
    focus_area: {
      type: [Boolean]
    },
    let_empty: {
      type: [Boolean],
      default: true
    }
  },
  data() {
    return {
      input_el: null,
      last_pos: null,
      key: '',
      key_code: null,
      last_value: null,
      ctrl: false
    }
  },
  methods: {
    keydown(e) { // 46(del), 8(backspace)
      this.last_pos = this.input_el.selectionEnd;
      if(this.last_pos === 0) {
        this.last_pos++;
      }
      this.key_code = e.keyCode;
      this.key = (!e.key || e.key === 'Unidentified') ? e.which : e.key;
      this.last_value = this.value;
      if(navigator.appVersion.indexOf('Mac') === -1) { // если мак
        this.ctrl = e.ctrlKey;
      } else {
        if(e.keyCode === 91 || e.keyCode === 93) { // если нажали cmd
          this.ctrl = true;
        }
      }
      let has_selection = this.input_el.selectionEnd !== this.input_el.selectionStart;
      if(has_selection === false) {
        if((e.keyCode === 8 && this.input_el.selectionEnd === 1) || (e.keyCode === 46 && this.input_el.selectionEnd === 0)) {
          e.preventDefault();
          return false;
        }
        if(e.keyCode !== 46 && e.keyCode !== 8 && this.key && this.key.length === 1) {
          if(this.key === '+') {
            if(this.input_el.selectionEnd !== 0 || (this.input_el.selectionEnd === 0 && this.input_el.value[0] === '+')) {
              e.preventDefault();
              return false;
            }
          }
        }
      }
    },
    keyup(e) {
      if(navigator.appVersion.indexOf('Mac') !== -1) {
        if(e.keyCode === 91 || e.keyCode === 93) {
          this.ctrl = false;
        }
      }
    },
    set_phone(e) {
      console.log('set_phone: ', e)
      let v = this.input_el.value;
      if(this.key_code === 46 && this.last_value[this.last_pos] === ' ') {
        // если удаляем del, надо удалить след после пробела символ
        v = this.last_value.substring(0, this.last_pos) + this.last_value.substring(this.last_pos + 2);
      }
      if(this.key_code === 8 && this.last_value[this.last_pos - 1] === ' ') {
        // если удаляем backspace, надо перескачить пробел и удалить след после пробела символ
        this.last_pos--;
        v = this.last_value.substring(0, this.last_pos - 1) + this.last_value.substring(this.last_pos);
      }
      /*
      if(v[0] !== '+' && Number(v[0]) === 8) {
        // решение костыльное есть страны начинающиеся с 8 возможно когда то проработаем
        v = '7' + v.substring(1);
      } */
      v = v.replace(/[^0-9, ]/g, ''); // удаляем невалидные символы
      v = '+' + v;
      v = formatIncompletePhoneNumber(v);
      if(v.match(/ /g) === null) { // не смогли отформатировать ввод
        let p = parsePhoneNumberFromString(v);
        if(p !== undefined) { // форматирование от кода страны сработало
          this.$emit('valid', false);
          let lp = parsePhoneNumberFromString(this.last_value);
          v = parsePhoneNumberFromString(v).formatInternational();
          // если редактирование происходит вне области страны, добавляем +1 к каретке
          // чтобы перескачить пробел
          if(lp === undefined && v.split(' ')[0].length < this.last_pos) {
            this.last_pos = this.last_pos + v.match(/ /g).length;
          } else if(v.split(' ')[0].length < this.last_pos) { // ввод должен быть вне зоны выбора страны
            // проверяем был ли шаблон у предыдущего ввода
            // если был то высчитываем изменение в пробелах и смещаем каретку
            let lph = new AsYouType();
            lph.input(this.last_value);
            let template = lph.getTemplate();
            if(template !== undefined) {
              this.last_pos = this.last_pos - (this.last_value.substring(0, this.last_pos).match(/ /g).length - 1);
            }
          }
        } else {
          this.$emit('valid', this.let_empty);
        }
      } else { // новое значение отформатировано
        let ph = parsePhoneNumberFromString(v);
        if(ph !== undefined) {
          this.$emit('valid', ph.isValid());
        } else {
          this.$emit('valid', false);
        }
        let lfp = formatIncompletePhoneNumber(this.last_value);
        if(lfp.match(/ /g) === null) { // прошлое значение было неотформатированно
          if(this.last_value.split(' ')[0].length < this.last_pos) {
            let str = formatIncompletePhoneNumber(this.last_value.substring(0, this.last_pos)) // форматируем обрезанную строку по позиции
            if(this.last_pos >= this.last_value.length) { // если каретка в конце строки
              this.last_pos = v.length + 1;
            } else {
              if(str.match(/ /g) !== null) {
                this.last_pos = this.last_pos + (str.match(/ /g).length - 1);
              }
            }
          }
        }
      }
      this.input_el.value = v; // форматируем введенное в инпут
      this.$emit('input', v);
      // Обрабатываем позицию каретки
      if(this.ctrl === false) {
        let pos = this.last_pos;
        this.$nextTick(r => {
          if(this.key && this.key.length > 1) { // символ не был введен(стрелки и т.п.), либо был удален
            switch(this.key_code) {
              case 8: { // backspace
                pos--;
                break;
              }
            }
          } else {
            if(v[pos] === ' ') {
              pos++;
            }
            pos++;
          }
          if(v[pos] === undefined) {
            pos = v.length;
          }
          this.input_el.selectionStart = pos;
          this.input_el.selectionEnd = pos;
        })
      }
    }
  },
  created() {
    if(this.value.match(/ /g) === null) {
      this.$emit('valid', this.let_empty);
    } else {
      let p = parsePhoneNumberFromString(this.value);
      if(p === undefined) {
        this.$emit('valid', false);
      } else {
        this.$emit('valid', p.isValid());
      }
    }
    /*
    if(this.value === '' && !this.placeholder) {
      this.$emit('input', '+' + this.value);
    }
    */
  },
  mounted() {
    this.input_el = this.$refs.vinput.$refs.input;
  }
}
</script>

<style>

</style>